
import { Component, Prop, Vue } from 'vue-property-decorator'
import BacModal from '../../BacModal.vue'
import BacButton from '../../BacButton.vue'
import BacInput from '../../BacInput.vue'

import { FixedValueDiscount } from '../../../lib/models/FixedValueDiscount'
import UIkit from 'uikit'
import { DateUtils } from '../../../lib/utils/DateUtils'

@Component({ components: { BacModal, BacButton, BacInput } })
export default class FixedValueDiscounts extends Vue {
  search = ''

  discounts: FixedValueDiscount[] = []
  selectedDiscount = new FixedValueDiscount()

  DateUtils = DateUtils

  headers = [
    { text: 'E-Mail', value: 'email', width: 120 },
    { text: 'Name', value: 'name', width: 120 },
    { text: 'Initialwert', value: 'initialValue', width: 10 },
    { text: 'Restwert', value: 'restValue', width: 10 },
    { text: 'Gültig bis', value: 'validTilExternal', width: 20 },
    { text: 'Info', value: 'info', width: 20 },
    { text: 'Aktionen', value: 'actions', width: 20 }
  ]

  mounted () {
    this.loadDiscounts()
  }

  async loadDiscounts () {
    this.discounts = await FixedValueDiscount.getAll({})
  }

  async saveDiscount () {
    const error = this.validateSelectedDiscount()
    if (error) {
      UIkit.notification({
        message: error,
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      return
    }
    if (!this.selectedDiscount.id) {
      await this.selectedDiscount.create()
    } else {
      await this.selectedDiscount.update()
    }
    await this.loadDiscounts()
    UIkit.modal('#add-fixed-discount-modal').hide()
  }

  validateSelectedDiscount (): string {
    if (!this.selectedDiscount.name) {
      return 'Bitte gib einen Namen für den Discount an!'
    }
    if (!this.selectedDiscount.email && !this.selectedDiscount.customerId) {
      return 'Ein Discount muss entweder eine E-Mail hinterlegt oder einem Teilnehmer zugewiesen sein!'
    }
    if (!this.selectedDiscount.initialValue) {
      return 'Der Discount muss einen Wert haben!'
    }
    return ''
  }

  async deleteDiscount () {
    if (!this.selectedDiscount.id) {
      return
    }
    await FixedValueDiscount.delete(this.selectedDiscount.id)
    await this.loadDiscounts()
    UIkit.modal('#delete-fixed-discount-modal').hide()
  }

  resetSelectedDiscount () {
    this.selectedDiscount = new FixedValueDiscount()
  }

  get items () {
    return this.discounts
  }
}
